import { render, staticRenderFns } from "./LpuCardsFiltersDrawer.vue?vue&type=template&id=2b3a28d0&"
import script from "./LpuCardsFiltersDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsFiltersDrawer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3a28d0')) {
      api.createRecord('2b3a28d0', component.options)
    } else {
      api.reload('2b3a28d0', component.options)
    }
    module.hot.accept("./LpuCardsFiltersDrawer.vue?vue&type=template&id=2b3a28d0&", function () {
      api.rerender('2b3a28d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsFiltersDrawer.vue"
export default component.exports